<template>
  <div style="height:100%;" class="d-flex justify-center">
    <v-dialog v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Recuperación en curso</p>
          <p v-if="email" class="text-center">
            Te hemos enviado un email de confirmación a
            <strong>{{email}}</strong>
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/mis-citas" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">No se ha podido iniciar la recuperación</p>
          <p class="text-center">El paciente no se ha encontrado o no cuenta con email registrado</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogError = false;" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="d-flex flex-column align-center pa-4 mt-8" style="max-width:600px">
      <div class="d-flex justify-start">
        <div class="d-flex flex-column" style="width: 350px;">
          <div>
            <v-text-field
              v-model="rut"
              label="Rut"
              outlined
              prepend-inner-icon="person"
              :rules="[
                () => !!rut || 'Campo requerido',
                () => isValidRut() || 'Rut inválido' 
              ]"
              validate-on-blur
            ></v-text-field>
          </div>
          <div class="d-flex">
            <v-btn
              class="flex"
              @click="recovery"
              :disabled="!rut"
              color="primary"
            >Recuperar contraseña</v-btn>
          </div>
          <v-btn to="/registrarse" text class="mt-4">Registrarse</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    rut: "",
    email: "",
    dialogSuccess: false,
    dialogError: false
  }),
  methods: {
    isValidRut() {
      let validRut = false;
      if (!this.rut) {
        return false;
      }
      if (this.rut.length < 7) {
        return false;
      }

      let cleanRut = this.$rutjs.clean(this.rut);
      validRut = this.$rutjs.validate(cleanRut);
      if (validRut) {
        this.rut = this.$rutjs.format(cleanRut);
      }
      return validRut;
    },
    async recovery() {
      try {
        const axios = require("axios");
        let { data } = await axios.post("passwordRecovery", {
          rut: this.rut.replace(/\./g, "")
        });
        this.email = data.email;
        this.dialogSuccess = true;
      } catch (err) {
        this.dialogError = true;
      }
    }
  }
};
</script>

<style>
</style>